import React, { useState } from "react";
import { Box, TextField, Button, CircularProgress } from "@mui/material";
import axios from "../../../config/axiosConfig";

// Estado 5 (Entregado) de una OT de Reemplazo: espejo simplificado de concluyendo.php
// (sin el formulario de precios — mismo criterio que ya usa ConcluirOT.jsx). Igual que
// Mantenimiento, salta directo de "Entregado" a "Finalizado" sin firma. El PDF final
// es el mismo "Nota de Entrega" que ya usa Adición (concluyendo.php redirige a
// ot_fin.php en el sistema viejo) — no hace falta un PDF nuevo para Reemplazo.
const FinalizarReemplazoOT = ({ cod_ot, onFinalizado }) => {
  const [observacion, setObservacion] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const finalizar = async () => {
    if (!window.confirm("¿Finalizar este Reemplazo? Quedará como Finalizado.")) return;
    setGuardando(true);
    setError("");

    const pdfWindow = window.open("", "_blank");
    if (pdfWindow) {
      pdfWindow.opener = null;
      pdfWindow.document.title = "Generando Nota de Entrega...";
      pdfWindow.document.body.innerHTML =
        '<div style="font-family:Arial,sans-serif;padding:24px;color:#334155">Finalizando y generando la Nota de Entrega...</div>';
    }

    try {
      const res = await axios.patch(`/api/ot-reemplazo/finalizar/${cod_ot}`, { observacion });
      if (onFinalizado) onFinalizado(res.data);

      if (pdfWindow) {
        try {
          const { data } = await axios.get(`/api/ot-solicitudes/${cod_ot}/nota-entrega.pdf`, { responseType: "blob" });
          const pdfUrl = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
          pdfWindow.location.replace(pdfUrl);
          setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
        } catch {
          pdfWindow.close();
        }
      }
    } catch (err) {
      if (pdfWindow) pdfWindow.close();
      setError(err?.response?.data?.error || "No se pudo finalizar el Reemplazo.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      {error && <Box sx={{ color: "error.main", fontSize: 13, mb: 1.5 }}>{error}</Box>}
      <TextField
        label="Observación"
        fullWidth
        multiline
        rows={3}
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="success" onClick={finalizar} disabled={guardando}>
          {guardando ? <CircularProgress size={20} color="inherit" /> : "Finalizar Reemplazo"}
        </Button>
      </Box>
    </Box>
  );
};

export default FinalizarReemplazoOT;
